import { getDomain } from 'tldts';

import { useMainMachine } from '../../../utils/useMainMachine';
import { formatEditorDistanceToNow } from '../../../utils/date';
import { Modal } from '../../../modal/Modal';

export function HistoryModal() {
  const { useSelector } = useMainMachine();
  const page = useSelector(({ context }) => context.editor.pages.find((p) => p.id === context.activePageId));
  const timeZone = useSelector(({ context }) => context.timeZone);

  const domain = getDomain(page.url);

  const pathname = new URL(page.url).pathname;
  let displayName = domain;
  if (pathname !== '/') {
    displayName = `${domain}${pathname}`;
  }

  // History is an append-only log, so an entry's position is its identity. Entry content is not
  // unique: the same change and its undo/redo recorded within one second (timestamps are in whole
  // seconds) would share a key, and React then leaves stale entries in the list.
  const reversedHistory = page.history.map((item, index) => ({ item, index })).reverse();

  return (
    <Modal dialogClassName="!top-[150px] !translate-y-0 !w-[700px] !min-h-[250px] !pr-0 !pl-[30px] !pt-6">
      <Modal.Title className="!mb-0 leading-none">Page changelog</Modal.Title>

      <p className="text-gray-200">
        A breakdown of all activity made on <span className="text-white">{displayName}</span>
      </p>
      <div className="flex flex-col styled-scrollbar relative mt-[30px] max-h-full overflow-y-auto pr-10">
        <div className="relative pl-9">
          <div className="absolute left-5 top-0.5 h-[calc(100%_-_2px)] w-0.5 bg-gray-500" />
          {reversedHistory.map(({ item, index }) => (
            <div key={index} className="mb-5 text-xs relative flex justify-between" data-testid="history-entry">
              <div className="absolute -left-5 top-0.5 w-[11px] h-[11px] rounded-full border-2 border-gray-500 bg-gray-900" />
              <div>
                <div className="text-gray-200">{item.headline}</div>
                <div className="text-white whitespace-pre-wrap">{item.body}</div>
              </div>
              <div className="text-2xs text-gray-200 shrink-0 ml-5">
                {formatEditorDistanceToNow(Math.floor(item.timestamp) * 1000, timeZone)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
